<section
    class="events-area bg-f9f9f9 pt-100 pb-70"
    [class.dark-events-area]="themeService.isDark()"
>
    <div class="container">
        <div class="section-title">
            <span class="sub-title" i18n>Events</span>
            <h2 i18n>Our Upcoming Events</h2>
            <!-- <p>This section showcases all events hosted and sponsored by our foundation. Explore upcoming seminars, workshops, and research presentations on geography, history, and culture.</p> -->
        </div>
        <div class="row">
            <div class="col-lg-6 col-md-12 col-sm-12" *ngFor="let event of events">
                <div class="events-box">
                    <div class="row m-0">
                        <div class="col-lg-5 col-md-5 p-0">
                            <div class="image" style="background-image: url({{imageUrl}}{{event.image}})">
                                <a routerLink="/events/{{event.id}}"></a>
                                <div class="divider-shape"></div>
                            </div>
                        </div>
                        <div class="col-lg-7 col-md-7 p-0">
                            <div class="content">
                                <div class="date">
                                    <span i18n>{{event.event_date|date:'medium'}}</span>
                                </div>
                                <h3><a routerLink="/events/{{event.id}}">{{event.title}}</a></h3>
                                <p>{{event.event_contact}}</p>
                                <span class="location"><i class="bx bx-map"></i>{{event.event_location}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            
        </div>
    </div>
    <div class="business-shape7"><img src="assets/img/business-coaching/business-shape4.png" alt="image"></div>
</section>